import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';

export const getRevisionComponentCountQueryKey = (
  revisionLocator: string,
): QueryKey => ['binary', revisionLocator, 'components', 'count'];

function getRevisionComponentCount(revisionLocator: string) {
  return get<{ count: number }>(`/api/binary/revision/${nuc(revisionLocator)}/components/count`, false);
}

/**
 * Helper hook for fetching the number of components in a given revision.
 * @param revisionLocator - The revision locator of the user's revision.
 * @returns A query for the number of components in the given revision.
 */
export default function useGetRevisionComponentCount(revisionLocator: string) {
  return useQuery<{ count: number }>({
    queryKey: getRevisionComponentCountQueryKey(revisionLocator),
    queryFn: () => getRevisionComponentCount(revisionLocator),
  });
}
